import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import styled from '@emotion/styled';

import Box from '@mui/material/Box';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';

import { useNavigate, useLocation } from 'react-router-dom';

import { ROLE } from '../../constants';

export default function Menu({ role }) {
    let navigate = useNavigate();
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const [colorsBG, setColorsBG] = useState({
        newReceipt: '#6b6d78',
        reports: '#313238',
        cashAndCashiers: '#313238',
        cashLogs: '#313238',
        serviceReceipts: '#313238',
    });

    const setBGcolor = target => {
        let newColors = {};
        Object.keys(colorsBG).map(key => {
            if (key === target) {
                newColors[key] = '#6b6d78';
            } else {
                newColors[key] = '#313238';
            }
        });
        setColorsBG(newColors);
    };

    return (
        <Box
            sx={{
                backgroundColor: '#313238',
                height: '100%',
                position: 'fixed',
            }}
        >
            <Menus sx={{ marginTop: 2 }}>
                {(role === ROLE.operator || role === ROLE.cashier) && (
                    <MenuItem
                        sx={{ backgroundColor: colorsBG.newReceipt }}
                        selected={pathname.includes('/client/new-receipt')}
                    >
                        <ListItemText
                            sx={{ color: '#FFFFFF' }}
                            onClick={() => {
                                setBGcolor('newReceipt');
                                navigate('/client/new-receipt');
                            }}
                        >
                            {t('create_new_receipt')}
                        </ListItemText>
                    </MenuItem>
                )}
                <MenuItem
                    sx={{ backgroundColor: colorsBG.reports }}
                    selected={pathname.includes('/client/reports')}
                >
                    <ListItemText
                        sx={{ color: '#FFFFFF' }}
                        onClick={() => {
                            setBGcolor('reports');
                            navigate('/client/reports');
                        }}
                    >
                        {t('cash_report')}
                    </ListItemText>
                </MenuItem>
                <MenuItem
                    sx={{ backgroundColor: colorsBG.cashLogs }}
                    selected={pathname.includes('/client/cash-logs')}
                >
                    <ListItemText
                        sx={{ color: '#FFFFFF' }}
                        onClick={() => {
                            setBGcolor('cashLogs');
                            navigate('/client/cash-logs');
                        }}
                    >
                        {t('check_journal')}
                    </ListItemText>
                </MenuItem>
                <MenuItem
                    sx={{ backgroundColor: colorsBG.serviceReceipts }}
                    selected={pathname.includes('/client/service-receipts')}
                >
                    <ListItemText
                        sx={{ color: '#FFFFFF' }}
                        onClick={() => {
                            setBGcolor('serviceReceipts');
                            navigate('/client/service-receipts');
                        }}
                    >
                        {t('service_checks')}
                    </ListItemText>
                </MenuItem>
                {role === ROLE.director && (
                    <MenuItem
                        sx={{
                            backgroundColor: colorsBG.serviceReceipts,
                            '&.Mui-selected': {
                                backgroundColor:
                                    'rgba(255, 255, 255, 0.5) !important',
                            },
                        }}
                        selected={pathname.includes('/client/users')}
                    >
                        <ListItemText
                            sx={{ color: '#FFFFFF' }}
                            onClick={() => {
                                setBGcolor('serviceReceipts');
                                navigate('/client/users');
                            }}
                        >
                            {t('users')}
                        </ListItemText>
                    </MenuItem>
                )}
                {(role === ROLE.director ||
                    role === ROLE.operator ||
                    role === ROLE.accountant) && (
                    <MenuItem
                        sx={{
                            backgroundColor: colorsBG.serviceReceipts,
                            '&.Mui-selected': {
                                backgroundColor:
                                    'rgba(255, 255, 255, 0.5) !important',
                            },
                        }}
                        selected={pathname === '/client/taxes'}
                    >
                        <ListItemText
                            sx={{ color: '#FFFFFF' }}
                            onClick={() => {
                                setBGcolor('serviceReceipts');
                                navigate('/client/taxes');
                            }}
                        >
                            {t('TVA_taxes')}
                        </ListItemText>
                    </MenuItem>
                )}
            </Menus>
        </Box>
    );
}

const Menus = styled(MenuList)`
    .MuiMenuItem-root {
        background-color: transparent !important;
    }
    .Mui-selected {
        background-color: rgba(255, 255, 255, 0.5) !important;
    }
`;
